import React, { useEffect, useState } from 'react'
import HotelForm from '../../components/Forecast/HotelForm'
import ForcastTables from '../../components/Forecast/ForcastTables'

function UpdateForecast() {
    

    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create Forecast</h4>
                        {/* <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button> */}
                    </div>

                    <div className="card-body">
                        {/* <HotelForm /> */}
                        <ForcastTables />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpdateForecast